<!--时间 TIME-->
<template>
  <div class="question-container" style="border: 1px solid #edeff2">
    <div class="question-type">时间</div>
    <div class="title-view" :style="{ marginRight: '' }">
      <p style="color: #4c4a56">
        <span v-if="dataObj.isMust === 1" class="asterisk">*</span>
        {{ `${dataObj.questionIndex ? dataObj.questionIndex : index + 1}、` }}
        <span style="color: #4c4a56">
          {{ `${dataObj.caseProblem}` }}
        </span>
      </p>
    </div>
    <el-time-select
      v-if="operate === 'answer'"
      v-model="value"
      placeholder="选择时间"
      style="width: 100%"
      format="HH:mm"
      value-format="HH:mm"
    >
    </el-time-select>
    <div v-else class="select-view">
      <p style="font-size: 14px; color: #2b2f36; word-break: break-all">
        {{ answerText || "时间选择" }}
      </p>
      <i class="el-icon-date" size="16px"></i>
    </div>
  </div>
</template>

<script>
import { valid } from "semver";

export default {
  props: {
    params: {
      type: Object,
      default: {},
    },
    operate: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      dataObj: {},
      index: 0,
      isMultiple: true,
      answerText: "",
      value: "",
    };
  },
  methods: {},
  watch: {
    params: {
      handler(newVal, oldVal) {
        this.dataObj = newVal.data;
        this.index = newVal.index;

        if (
          newVal.answer &&
          Array.isArray(newVal.answer.answer) &&
          newVal.answer.answer.length > 0
        ) {
          this.answerText = newVal.answer.answer[0].context || "";
        } else {
          this.answerText = "";
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
.select-view {
  width: 100%;
  min-height: 44px;
  background-color: #f9f9f9;
  border-radius: 3px;
  margin-top: 12px;
  padding: 0 12px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #ededed;
}
</style>



// WEBPACK FOOTER //
// src/components/QuestionPreview/QuestionPreviewTime.vue